import _ from "lodash"
import { useCallback } from "react"
import { useFindObjectRelationProperty } from "./useFindObjectRelationProperty"

export const useMutationRelationRemoved = () => {

    const findRelationPropertyId = useFindObjectRelationProperty()

    const getDiff = useCallback((oldObject: Record<string, any>, newObject: Record<string, any>) => {
        const result: Record<string, any> = {}

        Object.keys(oldObject).forEach((key) => {
            const oldValue = oldObject[key]
            const newValue = newObject[key]

            if (
                Array.isArray(oldValue) 
                && Array.isArray(newValue) 
                && !_.isEqual(oldValue, newValue) 
                ) {

                const newRelations = newValue.map((item, index) => {
                    const oldItem = oldValue[index]
                    return { ...oldItem, ...item }
                })

                result[key] = oldValue.filter((item) => !newRelations.some((item1) => {
                    const relationId = findRelationPropertyId(item)
                    return relationId && item[relationId] === item1[relationId]
                })).map((item) => {
                    const relationId = findRelationPropertyId(item) 
                    return relationId && relationId && item[relationId]
                }).filter((item) => item !== undefined)
            }
        })
        
        return result
    }, [])

    return getDiff
}
